import COMMON_ROUTES from '../common/routes'

const mergedRoutes = {
  ...COMMON_ROUTES,

  ACCOUNTS_MARKETPLACE: '/:i18n/accounts-marketplace',
  ACCOUNTS_MARKETPLACE_CATEGORY: '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)',
  ACCOUNTS_MARKETPLACE_CATEGORY_PRODUCTS:
    '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)/products',
  ACCOUNTS_MARKETPLACE_PRODUCT:
    '/:i18n/accounts-marketplace/category/:categoryId([0-9]+)/products/:productId([0-9]+)',
}

export { mergedRoutes as ROUTES }
